// Assuming your JSON file is named data.json and located in the same directory
import jsonData from './data.json';

const transformData = () => {
  const transformedData = jsonData.map(topLevelItem => ({
    title: topLevelItem.name, // Adjust based on your JSON structure
    visible: false,
    children: topLevelItem.children.map(secondLevelItem => ({
      title: secondLevelItem.name,
      visible: false,
      children: secondLevelItem.children.map(thirdLevelItem => ({
        title: thirdLevelItem.name,
        visible: false,
        children: [] // Adjust as necessary
      }))
    }))
  }));

  return transformedData;
};

export default transformData();

// export default [
//   {
//     title: '第一级菜单',
//     visible: false,
//     children: [
//       {
//         title: '第二级菜单 A',
//         visible: false,
//         children: [
//           { title: '第三级菜单 A-1' },
//           { title: '第三级菜单 A-2' }
//         ]
//       },
//       {
//         title: '第二级菜单 B',
//         visible: false,
//         children: [
//           { title: '第三级菜单 B-1' },
//           { title: '第三级菜单 B-2' }
//         ]
//       }
//     ]
//   },
//   {
//     title: '第一级菜单 C',
//     visible: false,
//     children: [
//       {
//         title: '第二级菜单 A',
//         visible: false,
//         children: [
//           { title: '第三级菜单 A-1' },
//           { title: '第三级菜单 A-2' }
//         ]
//       },
//       {
//         title: '第二级菜单 B',
//         visible: false,
//         children: [
//           { title: '第三级菜单 B-1' },
//           { title: '第三级菜单 B-2' }
//         ]
//       }
//     ]
//   }
// ];
